



































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeCadastroMedicoStore from '@/components/Backoffice/Store/BackofficeCadastroMedicoStore'
import { DataTablePagination } from '@/types/_'
import _ from 'lodash'

/* EventBus */
import EventBus from '@/plugins/EventBus'

@Component

export default class ComponentBackofficeMedicosCadastradosTable extends Vue {
  @Prop({ required: false, default: '' }) tabName: string

  $refs!: {
    modalBackofficeAlterarMedico: any,
  }

  medicosCadastradosTableHeaders: any[] = [
    { text: 'Nome', class: 'table-headers', align: 'left', value: 'nome', sortable: false },
    { text: 'CPF', class: 'table-headers', align: 'left', value: 'cpf', sortable: false },
    { text: 'Ações', class: 'table-headers', align: 'center', value: '', sortable: false },
  ]

  loadEditarMedico: string = ''
  get loadingEditarMedico() { return this.loadEditarMedico }
  set loadingEditarMedico(value: string) { this.loadEditarMedico = value }

  loadVisualizarMedico: string = ''
  get loadingVisualizarMedico() { return this.loadVisualizarMedico }
  set loadingVisualizarMedico(value: string) { this.loadVisualizarMedico = value }

  loadVisualizarAssinatura: string = ''
  get loadingVisualizarAssinatura() { return this.loadVisualizarAssinatura }
  set loadingVisualizarAssinatura(value: string) { this.loadVisualizarAssinatura = value }

  loadMedicosCadastrados: boolean = false
  get loadingMedicosCadastrados() { return this.loadMedicosCadastrados }
  set loadingMedicosCadastrados(value: boolean) { this.loadMedicosCadastrados = value }

  get medicosSearch() { return this.getBackofficeCadastroMedicoStore.medicosSearch }
  set medicosSearch(value: string) { this.getBackofficeCadastroMedicoStore.setMedicosSearch(value) }

  @Watch('medicosSearch')
  async onChangeMedicosSearch(value: any) {
    this.medicosCadastradosDebounce({})
  }

  get paginationMedicosCadastrados() {
    return this.getBackofficeCadastroMedicoStore.paginationMedicosCadastrados
  }

  get getBackofficeCadastroMedicoStore() {
    return getModule(BackofficeCadastroMedicoStore, this.$store)
  }

  get medicos() {
    return this.getBackofficeCadastroMedicoStore.medicos
  }

  get podeSerAlterado() {
    return this.getBackofficeCadastroMedicoStore.podeSerAlterado
  }

  get medicoReadonly() {
    return this.getBackofficeCadastroMedicoStore.medicoReadonly
  }

  async resetSearch() {
    this.getBackofficeCadastroMedicoStore.resetPaginationMedicoCadastrado()
    this.loadMedicosCadastrados = true
    this.medicosCadastradosDebounce(this.paginationMedicosCadastrados)
    this.loadMedicosCadastrados = false
  }

  medicosCadastradosDebounce = _.debounce(param => this.getBackofficeCadastroMedicoStore.getAllCadastrosMedicosByUsuarioHospital(param), 700)

  async updatePaginationMedicosCadastrados(pagination: DataTablePagination) {
    // Força a atualização somente na segunda tab...
    if (this.tabName !== 'tab-2') return
    this.loadMedicosCadastrados = true
    this.medicosCadastradosDebounce(pagination)
    this.loadMedicosCadastrados = false
  }

  async getMedicoDadosPreCadastro(medico: any) {
    this.loadingEditarMedico = medico.medicoId
    this.$refs.modalBackofficeAlterarMedico.firstCPF = medico.cpf
    const request = await this.getBackofficeCadastroMedicoStore.getMedicoDadosPreCadastro(medico.medicoId)
    if (request.success) {
      this.getBackofficeCadastroMedicoStore.setMedicoReadonly(medico.edicaoRestrita)
      this.getBackofficeCadastroMedicoStore.setModal({ name: 'alterarMedico', value: true })
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: request.message || 'Ocorreu um erro na requisição.', icon: 'warning', color: '#C62828' })
    }
    this.loadingEditarMedico = ''
  }

  async visualizarAssinatura(id: string) {
    this.loadingVisualizarAssinatura = id
    await this.getBackofficeCadastroMedicoStore.getBackofficeAssinaturaDoMedico(id)
    this.getBackofficeCadastroMedicoStore.setModal({ name: 'assinaturaMedico', value: true })
    this.loadingVisualizarAssinatura = ''
  }
}
